function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PopupMainTemplate = require('./main.template');
var TestimonialsTemplate = require('./testimonials.template');
var PopupMain = /*#__PURE__*/function () {
  function PopupMain(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, PopupMain);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.name = 'PopupMain';
    this.app.connection.on('popup-home-render-request', function () {
      _this.render();
    });
    this.app.connection.on('popup-lessons-render-request', function () {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
      document.querySelector('.saito-main').innerHTML = '';
      document.querySelector('.saito-sidebar.right').innerHTML = '';
      _this.mod.manager.render(level);
    });
    try {
      this.app.connection.on('popup-lesson-render-request', function (lesson_id) {
        document.querySelector('.saito-main').innerHTML = '';
        document.querySelector('.saito-sidebar.right').innerHTML = '';
        _this.mod.lessonui.render(lesson_id);
      });
    } catch (err) {}
    try {
      this.app.connection.on('popup-vocab-render-request', function () {
        var review_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        document.querySelector('.saito-main').innerHTML = '';
        document.querySelector('.saito-sidebar.right').innerHTML = '';
        _this.mod.vocab.render(review_id, offset);
      });
    } catch (err) {}
  }
  return _createClass(PopupMain, [{
    key: "render",
    value: function render() {
      if (!document.querySelector('.saito-container')) {
        this.app.browser.addElementToDom(PopupMainTemplate(this.mod));
        this.app.browser.addElementToSelector(TestimonialsTemplate(), '.saito-main');
      } else {
        this.app.browser.replaceElementBySelector(PopupMainTemplate(this.mod), '.saito-container');
        document.querySelector('.saito-main').innerHTML = '';
        this.app.browser.addElementToSelector(TestimonialsTemplate(), '.saito-main');
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        document.querySelector('.popup-home').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons');
          history.replaceState(null, null, ' ');
          _this2.app.connection.emit('popup-home-render-request', 'all');
        };
      } catch (err) {}
      try {
        document.querySelector('.popup-lessons').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/lessons');
          history.replaceState(null, null, ' ');
          _this2.app.connection.emit('popup-lessons-render-request', 'all');
        };
      } catch (err) {}
      try {
        document.querySelector('.popup-vocab').onclick = function (e) {
          window.history.pushState({}, document.title, '/popup/review');
          history.replaceState(null, null, ' ');
          //this.app.connection.emit('popup-vocabulary-render-request', 'all');
          _this2.app.connection.emit('popup-vocab-render-request', ('', 0));
        };
      } catch (err) {}
    }
  }]);
}();
module.exports = PopupMain;